(() => {
  'use strict';
  function init(root) {
    if (!root || root.dataset.tabsReady === 'true') return;
    root.dataset.tabsReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-tour-tab]'));
    const cards = Array.from(root.querySelectorAll('[data-tour-card]'));
    const grid = root.querySelector('[data-tour-grid]');
    const more = root.querySelector('[data-tour-more]');
    const empty = root.querySelector('[data-tour-empty]');
    const status = root.querySelector('[data-tour-status]');
    const limit = Number(root.dataset.upcomingLimit) || 3;
    let expanded = false;
    let current = tabs.find(tab => tab.getAttribute('aria-pressed') === 'true')?.dataset.tourTab || tabs[0]?.dataset.tourTab;
    const nearestByTour = new Set();
    const upcoming = cards.filter(card => card.dataset.upcoming === 'true')
      .sort((a, b) => a.dataset.departure.localeCompare(b.dataset.departure))
      .filter(card => {
        const tourKey = card.dataset.tourKey === 'manual' ? '' : card.dataset.tourKey;
        const key = tourKey || card.dataset.tourTitle || card.dataset.blockId;
        if (nearestByTour.has(key)) return false;
        nearestByTour.add(key);
        return true;
      });
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function activate(value, moveFocus = false) {
      if (!tabs.some(tab => tab.dataset.tourTab === value)) return;
      if (value !== current) expanded = false;
      current = value;
      const activeTab = tabs.find(tab => tab.dataset.tourTab === value);
      const matches = value === 'upcoming' ? upcoming : cards.filter(card => card.dataset.tabGroup === value);
      const visible = value === 'upcoming' && !expanded ? matches.slice(0, limit) : matches;
      const shown = new Set(visible);
      cards.forEach(card => { card.hidden = !shown.has(card); });
      matches.forEach(card => grid.appendChild(card));
      tabs.forEach(tab => {
        const active = tab === activeTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', String(active));
      });
      if (more) {
        more.hidden = value !== 'upcoming' || matches.length <= limit;
        more.setAttribute('aria-expanded', String(expanded));
        more.textContent = expanded ? more.dataset.lessLabel : more.dataset.moreLabel;
      }
      if (empty) empty.hidden = matches.length !== 0;
      if (status) status.textContent = (matches.length === 1 ? status.dataset.one : status.dataset.other).replace('[count]', String(matches.length));
      if (moveFocus) activeTab.focus({preventScroll: true});
      if (moveFocus || document.activeElement === activeTab) {
        const nav = activeTab.parentElement;
        const left = activeTab.offsetLeft - nav.offsetLeft - (nav.clientWidth - activeTab.offsetWidth) / 2;
        nav.scrollTo({left, behavior: reducedMotion ? 'auto' : 'smooth'});
      }
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.tourTab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(tabs[next].dataset.tourTab, true);
      });
    });
    if (more) more.addEventListener('click', () => { expanded = !expanded; activate(current); });
    document.addEventListener('shopify:block:select', event => {
      const selected = cards.find(card => card.dataset.blockId === event.detail?.blockId);
      if (selected) activate(selected.dataset.tabGroup);
    });
    activate(current);
  }
  document.querySelectorAll('[data-mr-tour-pdf]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches('[data-mr-tour-pdf]')) init(event.target);
    event.target.querySelectorAll('[data-mr-tour-pdf]').forEach(init);
  });
})();
